module.exports = __webpack_public_path__ + "img/35.2d322d1e.jpg";